
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:SocialLogin:Loaded', function(event){  
   var data = event.detail.settings;
     data.redirectUrlFormSelector = ['form#header_customer_login', 'form#create_customer', 'form#RegisterForm', '.shopify-challenge__container form', '.shopify-challenge__container form'];
 });
  // Wishlist
if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
    Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
  }
  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
    Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
    
    // TO display Credit Balance In Hamburger Menu
    var moneyFormat = Flits.money_format;
    Flits.getStoreCredit(function(resp){
        Flits(".flits-slider-store-credit").html("Points<br>"+Flits.formatMoney(Math.abs(resp.customer.credits), moneyFormat))
    });


  }
  
  Flits(window).on('load',function(event) {
    setTimeout(function(){ 
      function wishListCollection() {
         let collectionBtn = Flits('.flits-wishlist-colection');
          parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
            Flits(collectionBtn).show(),
            Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
        }
     function wishlistLocalData() {
        var settings = {
            automaticAppendDivFunction: function() {},
            isWishlistAutomatic: 1,
            wslBtnType: 1,
            isCountEnable: 0,
            addtocartSelectors: ["form[action='/cart/add']"],
            wishListBtnDomSelector: 'flits-wishlist-dom',
            wishlist_base_url: '/wishlist',
            add_wsl_url: '/add_to_wishlist',
            remove_wsl_url: '/remove_from_wishlist',
            wishlistHandle: 'flits_wishlist_products',
            wishlistLastUpdate: 'last_wishlist_product_update',
            clicked_add_button: '',
            appearance_style: {
                before_heart_clr: '#000000',
                before_btn_clr: '#fff',
                before_text_clr: '#f5020f',
                before_border_clr: '#000000',
                after_heart_clr: '#fc0303',
                after_btn_clr: '#080707',
                after_text_clr: '#f5faf9',
                after_border_clr: '#f7f5fa',
                collection_before_heart_clr: '#000000',
                collection_after_heart_clr: '#fc0303'
            }
        };
        var wishlitsLocalHandles = Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistHandle);
        if (wishlitsLocalHandles) {
          var wishlitsLocalHandlesArray = wishlitsLocalHandles.split(',');
          console.log(wishlitsLocalHandlesArray.length);
          for (var i = 0; i < wishlitsLocalHandlesArray.length; i++) {
            var s = Flits("*[data-flits-product-handle='" + wishlitsLocalHandlesArray[i] + "']");	
            var wishlitsLocalHandlesnew = Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistHandle);
            var pro_handle = s.attr('data-flits-product-handle');
            if(Flits.isProductAddedInWishlist(pro_handle)){ 
              s.removeClass("flits-wls-inactive")
              s.addClass("flits-wls-active")
              s.attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button','Remove from Wishlist'));
            }     
          }
        }
      }
      wishlistLocalData();
      wishListCollection();
    }, 1000);
  });
  
    Flits(document).on('Flits:SocialLogin:Loaded', function(event){  
    setTimeout(function(){
      if (location.pathname.indexOf("/account") == -1){  
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }, 800);
  });

  Flits(window).load(function() {  
    if (location.pathname.indexOf("/account") == -1){     
      if (location.pathname.indexOf("checkout") != -1)
      {
        Flits.setLocalStorage('flits_before_login_url',location.pathname);
      }else{
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }
  });
  Flits(document).on('click', '#side-cart label[for="storeCredit"]', function(event){
    event.preventDefault();
    var creditTrue = Flits('input[type="checkbox"].flits-want-to-use-credit').is(":checked");
    if(creditTrue == true){
      Flits('input[type="checkbox"].flits-want-to-use-credit').prop('checked', false);
    }
    else{
      Flits('input[type="checkbox"].flits-want-to-use-credit').prop('checked', true);
    }
  });
  
}(Flits));
